<app-table [model]="details | schooldashboardTable:row:groeperenOpVak" (rowClick)="navigeerNaarVak($event)"></app-table>
